import {useCallback} from 'react';
import {ApiEmptyResponseContent, ApiResponse} from '@legit.health/backend-client';
import {DiagnosticReportId, generatePath} from '@legit.health/ui';
import useApiMutation from '@/shared/hooks/useApiMutation';

export default function usePatchDiagnosisSupportReport({
  onSuccess,
  onError
}: {
  onSuccess?: (data: ApiResponse<ApiEmptyResponseContent>) => void | Promise<unknown>;
  onError?: (error: Error) => void | Promise<unknown>;
}) {
  const {mutate, isPending, isError} = useApiMutation<ApiEmptyResponseContent>({
    options: {
      onSuccess: (response) => onSuccess?.(response),
      onError
    }
  });

  const patch = useCallback(
    async function ({
      data,
      diagnosticReportId
    }: {
      data: Record<string, any>;
      diagnosticReportId: DiagnosticReportId;
    }) {
      return mutate({
        method: 'PATCH',
        path: generatePath('/diagnosis-support-reports/:diagnosticReportId', {
          diagnosticReportId
        }),
        body: data
      });
    },
    [mutate]
  );

  return {patch, isPending, isError};
}
